// extracted by mini-css-extract-plugin
export default {"user":"src-components-Header-index__user--rYdeT","overlay":"src-components-Header-index__overlay--ONvg3","hidden":"src-components-Header-index__hidden--b28N9"};